module.exports = __webpack_public_path__ + "img/adori-logo-studio.d145dda6.svg";